<template>
    <div class="settlement-edc-content">
        <SOSlotBase :container-name="'pembayaran-edc-list-content'">
            <template v-slot:title-bar>
                <SOTitleBar :page-title="'Pembayaran'" :type="'back'" @back="back" />
            </template>
            <template v-slot:content>
                <div v-if="totalPembayaranEdc && (isMinExport || !isExporting)">
                    <SOExportProgressMinimized
                        v-if="isMinExport"
                        :processed-data="exportProgress.processed"
                        :total-data="exportProgress.total"
                        :context="'Riwayat Pembayaran edc'"
                        :tracker-actions="`${modulName}/exportTracker`"
                        @on-success="checkExport"
                        @on-error="exportFail"
                    />
                    <SOExportMultipleFile
                        v-if="isMultipleExport"
                        :export-data="dataExport"
                        :export-data-length="dataLength"
                        :delete-cluster-actions="`${modulName}/exportDeleteCluster`"
                        :delete-master-actions="`${modulName}/exportDeleteMaster`"
                        @done="finishExport"
                    />
                </div>
                <div>
                    <div style="background: #F2F5F7; padding: 12px 20px;">
                        {{ getDetailPembayaran.length }} Pembayaran
                    </div>
                    <div class="" v-for="(data, idx) in getDetailPembayaran" :key="`${idx}-pembayaran`">
                        <SOSlotCard :id="`card-pembayaran${data.id}`" :card-type="`none`">
                            <template v-slot:card_body>
                                <div class="f-c-midgrey f-regular f-13" @click="gotoNota(data.ref_transaksi)">
                                    <div class="d-flex-between-center f-16  f-c-black">
                                        <p class="m-d-0 f-semi">
                                            <label>{{ data.label_pembayaran }}</label>
                                            <img src="../../../assets/icons/chevron_right_4.svg" style="width: 24px" />
                                        </p>
                                        <p class="m-d-0" style="color: #24A148">+ {{ data.total | currency }}</p>
                                    </div>
                                    <div class="">
                                        <label class="m-d-0">{{ data.ref_transaksi }} • {{ getNamaOutlet }}</label>
                                    </div>
                                    <div>
                                        <label class="m-d-0">
                                            {{ data.waktu_pembayaran_formated }} oleh {{ dibuatOleh(data) }}
                                        </label>
                                    </div>
                                </div>
                            </template>
                        </SOSlotCard>
                    </div>
                    <div v-if="!isFetching && totalPembayaranEdc">
                        <SOFABExport @export="openModalExport" />
                    </div>
                </div>
            </template>
            <template v-slot:export-import>
                <div class="vh-100" v-if="isExporting && !isMinExport">
                    <SOExportProgress
                        :context="'Pembayaran EDC'"
                        :tracker-actions="`${modulName}/exportTracker`"
                        @on-success="checkExport"
                        @on-error="exportFail"
                        @minimized-export="minimizedExport"
                    />
                </div>
            </template>
        </SOSlotBase>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";

import SOSlotCard from "@/so-components/global/slot/SOSlotCard.vue";
import SOFABExport from "@/so-components/global/ui/SOFABExport";
import SOExportProgress from "@/so-components/global/ui/SOExportProgress";
import SOExportProgressMinimized from "@/so-components/global/ui/SOExportProgressMinimized";

import { moduleName } from "../store/state";

export default {
    name: "PembayaranEdcList",
    components: {
        SOSlotBase,
        SOTitleBar,
        SOSlotCard,
        SOFABExport,
        SOExportProgress,
        SOExportProgressMinimized,
    },
    data() {
        return {};
    },
    mounted() {
        if (!this.detailData) {
            this.back();
        }
    },
    computed: {
        ...mapGetters(moduleName, {
            detailSettlementEdc: "detailSettlementEdc",
            isFetching: "isFetching",
            exportData: "exportData",
            exportProgress: "exportProgress",
        }),
        modulName() {
            return moduleName;
        },
        isMinExport() {
            return this.exportData.minimized;
        },
        isExporting() {
            return this.exportData.exporting;
        },
        isMultipleExport() {
            return this.exportData.multiple;
        },
        dataExport() {
            return this.exportData.data;
        },
        dataLength() {
            return this.exportData.dataLength;
        },
        detailData() {
            return this.detailSettlementEdc.detail_data;
        },
        getDetailPembayaran() {
            return this.detailSettlementEdc.pembayaran_edc;
        },
        totalPembayaranEdc() {
            return this.getDetailPembayaran.length;
        },
        getNamaOutlet() {
            return this.detailData.outlet.nama;
        },
        dibuatOleh() {
            return (data) => {
                return data.karyawan && data.idkaryawan ? data.karyawan : "Owner";
            };
        },
    },
    methods: {
        ...mapActions({
            toggleExporting: `${moduleName}/toggleExporting`,
            setMinimized: `${moduleName}/setMinimized`,
            setMultiple: `${moduleName}/setMultiple`,
            exportTracker: `${moduleName}/exportTracker`,
            setData: `${moduleName}/setData`,
            setDataLength: `${moduleName}/setDataLength`,
            setExportProgress: `${moduleName}/setExportProgress`,
        }),
        back() {
            this.$router.go(-1);
        },
        gotoNota(dataId) {
            this.$router.push({
                name: "TransaksiDetail",
                params: { idtransaksi: dataId },
                query: { noAction: true },
            });
        },
        openModalExport() {
            this.$router.push({ name: "mesin.edc.detail.setoran.export" });
        },
        async checkExport() {
            this.toggleExporting(false);
            this.setMinimized(false);
            this.setMultiple(false);

            let tracker = await this.exportTracker();
            if (!tracker.success) {
                return;
            }

            this.setDataLength(tracker.data.length);

            if (tracker.data.info_data_export.length > 0) {
                if (tracker.data.status === 1) {
                    this.setMultiple(true);
                    this.setData(tracker.data.info_data_export);
                    if (this.dataExport.length > 0) {
                        this.dataExport.forEach((v) => {
                            v["downloaded"] = false;
                        });
                    }
                } else {
                    this.setMinimized(true);
                }
            }
        },
        exportFail() {
            this.toggleExporting(false);
        },
        minimizedExport(data) {
            this.setMinimized(true);
            this.setExportProgress(data);
        },
        finishExport() {
            this.setMultiple(false);
            this.setData([]);
        },
    },
};
</script>
